import { List, Map } from 'immutable'
import moment = require('moment')
import { AsyncState, HttpResult, loadingAsyncState } from 'widgets-for-react'
import { defaultLanguage, getLanguage } from '../../../public_site.main.mod'
import { ImageSize } from '../../cms/blocks/types.gen'
import { getDrupalLanguage } from '../../public_site/application.mod'
import { ParsedOverviewDetailItem } from '../../public_site/custom_pages/pages/overviewPage/components/overviewItemsBlock/overview_items_block'
import { PageKind } from '../../public_site/custom_pages/pages/overviewPage/overview_page'
import { htmlDecode, overview_tag_to_taxonomy_title, TagTitle, TagValues } from '../../public_site/custom_pages/types.mod'
import { ExtraImages, overviewpage_src, overviewpage_srcset } from '../../public_site/utils/extra_images.mod'
import { getLangFromUrl, removeLangFromUrl, updateUrlLang } from '../../public_site/utils/history.mod'
import {
  Breadcrumb,
  Pager,
  PaginatedItem,
  ParsedMenuItem,
  MenuItem,
  Locale,
  CustomParsedEntity,
  SearchResultItem
} from '../types_and_parser/extra_types.mod'
import {
  entity_parser,
  node_story_parser,
  node_story_guard
} from '../types_and_parser/parser'

// import { Footer } from "../../site/public_site";

export async function GetDrupalNode(_slug: string): Promise<HttpResult<CustomParsedEntity> & { is_preview: boolean }> {
  const lang: Locale | null = _slug ? getLangFromUrl() : 'global'
  const localePart = lang == 'global' ? '' : `/${lang}`
  const slug = lang == 'global' ? _slug : removeLangFromUrl(_slug)
  const is_preview = slug && slug?.startsWith("preview")

  const url = [undefined, null, '', '/', lang].includes(slug)
    ? `/api/drupal${localePart}/api/homepage`
    : (is_preview
      ? `/api/drupal${localePart}/api/${slug}` + window.location.search
      : `/api/drupal${localePart}/${slug}`)

  const res = await fetch(url, {
    method: 'GET',
    credentials: 'include'
  })

  if (!res.ok) return { kind: 'failed', status: 400, is_preview }

  const json = await res.json()

  if (Array.isArray(json)) {
    if (json.length == 0) return { kind: 'failed', status: 400, is_preview }

    const parsed = entity_parser(json.shift() as any)
    return { kind: 'result', status: 200, value: { ...parsed, locale: lang }, is_preview }
  }

  const parsed = entity_parser(json as any) as CustomParsedEntity
  return { kind: 'result', status: 200, value: { ...parsed, locale: lang }, is_preview }
}

export async function GetOverview<T>(
  api_name: string,
  lang: string,
  page?: number,
  taxonomy?: 'all' | string,
): Promise<HttpResult<PaginatedItem<T>>> {

  const locale = getLanguage(lang)

  const res = await fetch(
    `/api/drupal${locale == 'global' ? '' : `/${locale}`}/api/${api_name}${taxonomy != undefined && taxonomy != 'all' ? `/${taxonomy}` : ``
    }${page != null ? `?page=${page}` : ''}`,
    {
      method: 'GET',
      credentials: 'include'
    }
  )

  if (!res.ok) return { kind: 'failed', status: 400 }

  const type_parser = (t: any) => (node_story_guard(t) ? node_story_parser(t) : null)

  const json = await res.json()
  const pager = json['pager'] as Pager
  const items = json['items']

  let parsed: PaginatedItem<T>

  if (Array.isArray(json))
    parsed = {
      pager: pager,
      items: List<T>(json.map((j) => type_parser(j)))
    }
  else if (Array.isArray(items))
    parsed = {
      pager: pager,
      items: List<T>(items.map((j) => type_parser(j)))
    }
  else
    parsed = {
      pager: pager,
      items: List<T>(type_parser(items))
    }
  return { kind: 'result', status: 200, value: parsed }
}

export async function GetPressReleases<T>(
  // lang: string,
  // page?: number,
  // taxonomy?: 'all' | string
): Promise<HttpResult<PaginatedItem<T>>> {
  // const locale = getLanguage(lang)
  // const res = await fetch(
  //   `/api/drupal${locale == 'global' ? '' : `/${locale}`}/api/${api_name}${
  //     taxonomy != undefined && taxonomy != 'all' ? `/${taxonomy}` : ``
  //   }${page != null ? `?page=${page}` : ''}`,
  //   {
  //     method: 'GET',
  //     credentials: 'include'
  //   }
  // )

  const res = await fetch('/api/v1/globenewswire')

  if (!res.ok) return { kind: 'failed', status: 400 }

  const json = await res.json()
  const pager = json['pager'] as Pager
  const items = json['items']

  let parsed: PaginatedItem<T>

  // if (Array.isArray(json))
  //   parsed = {
  //     pager: pager,
  //     items: List<T>(json.map((j) => type_parser(j)))
  //   }
  // else if (Array.isArray(items))
  //   parsed = {
  //     pager: pager,
  //     items: List<T>(items.map((j) => type_parser(j)))
  //   }
  // else
  //   parsed = {
  //     pager: pager,
  //     items: List<T>(type_parser(items))
  //   }

  parsed = {
    pager: pager,
    items: List(json)
  }
  return { kind: 'result', status: 200, value: parsed }
}

export async function GetPressRelease<T>(id: string): // lang: string,
  // page?: number,
  // taxonomy?: 'all' | string
  Promise<HttpResult<T>> {
  // const locale = getLanguage(lang)
  // const res = await fetch(
  //   `/api/drupal${locale == 'global' ? '' : `/${locale}`}/api/${api_name}${
  //     taxonomy != undefined && taxonomy != 'all' ? `/${taxonomy}` : ``
  //   }${page != null ? `?page=${page}` : ''}`,
  //   {
  //     method: 'GET',
  //     credentials: 'include'
  //   }
  // )

  const res = await fetch(`/api/v1/globenewswire/${id}`)

  if (!res.ok) return { kind: 'failed', status: 400 }

  const json = await res.json()
  const press_releases = await GetPressReleases()
  if (press_releases.kind != "result" || !press_releases.value.items.find(release => release["id"] == json["id"]))
    return { kind: 'failed', status: 400 }

  return { kind: 'result', status: 200, value: json }
}

export async function GetPageTeaser<T>(ids: List<number>, lang: Locale): Promise<HttpResult<List<T>>> {
  const res = await fetch(`/api/drupal/${lang ? lang : defaultLanguage}/api/page-teaser/${ids.join('+')}`, {
    method: 'GET',
    credentials: 'include'
  })
  if (!res.ok) return { kind: 'failed', status: 400 }

  let parsed: List<T>

  const json = await res.json()
  if (Array.isArray(json)) {
    if (json.length == 0) return { kind: 'failed', status: 400 }
    parsed = List<T>(json.map((v) => entity_parser(v)))
  } else {
    parsed = List<T>(entity_parser(json))
  }

  return { kind: 'result', status: 200, value: parsed }
}

export async function getMenu(url: string): Promise<HttpResult<List<ParsedMenuItem>>> {
  const res = await fetch(url, {
    method: 'GET',
    credentials: 'include'
  })
  if (!res.ok) return { kind: 'failed', status: 404 }
  const json = await res.json()
  return { kind: 'result', value: parse_menu(json), status: 200 }
}

export const parse_menu = (t: MenuItem[]): List<ParsedMenuItem> => {
  return List(t.map(menu_item_parser))
}

const menu_item_parser = (t: MenuItem): ParsedMenuItem => ({
  key: t.key,
  label: t.title,
  relative: !!t.relative,
  url: t.relative ? t.relative : t.absolute,
  children: t.below ? List(t.below.map(menu_item_parser)) : null
})

//improve
// export const loadFooter = async (): Promise<HttpResult<any>> => {
//   const aboutUsCall = fetch(`/api/drupal/api/menu_items/about-us`, { credentials: 'include' })
//   const contactCall = fetch(`/api/drupal/api/menu_items/contact`, { credentials: 'include' })
//   const privacyCall = fetch(`/api/drupal/api/menu_items/privacy-cookie-footer`, { credentials: 'include' })

//   const aboutUs = await (await aboutUsCall).json()
//   const contact = await (await contactCall).json()
//   const privacy = await (await privacyCall).json()

//   return {
//     kind: 'result',
//     status: 200,
//     value: {
//       aboutUs: parse_menu(aboutUs),
//       contact: parse_menu(contact),
//       privacy: parse_menu(privacy)
//     }
//   }
// }
export const loadFooter = async (lang: Locale): Promise<HttpResult<List<ParsedMenuItem>>> => {
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.footer
      ? window.__PRELOADED_DATA__.menus.footer
      : await (
        await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/footer`, {
          credentials: 'include'
        })
      ).json()

  return {
    kind: 'result',
    status: 200,
    value: parse_menu(menuList)
  }
}

export const loadPrivacyMenu = async (lang: Locale): Promise<HttpResult<List<ParsedMenuItem>>> => {
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.privacy
      ? window.__PRELOADED_DATA__.menus.privacy
      : await (
        await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/privacy`, {
          credentials: 'include'
        })
      ).json()

  return {
    kind: 'result',
    status: 200,
    value: parse_menu(menuList)
  }
}

export const loadTopMenu = async (lang: Locale): Promise<HttpResult<List<ParsedMenuItem>>> => {
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.top
      ? window.__PRELOADED_DATA__.menus.top
      : await (
        await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/top`, { credentials: 'include' })
      ).json()

  return {
    kind: 'result',
    status: 200,
    value: parse_menu(menuList)
  }
}

export const loadCountryMenu = async (lang: Locale): Promise<HttpResult<List<ParsedMenuItem>>> => {
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.top
      ? window.__PRELOADED_DATA__.menus.top
      : await (
        await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/country`, { credentials: 'include' })
      ).json()

  return {
    kind: 'result',
    status: 200,
    value: parse_menu(menuList)
  }
}

type PreloadedData = {
  menus?: {
    top: any
    main: any
    footer: any
    privacy: any
  }
}

declare global {
  interface Window {
    __PRELOADED_DATA__: PreloadedData
  }
}

window.__PRELOADED_DATA__ = window.__PRELOADED_DATA__ || {}

export const loadHeader = async (lang: Locale): Promise<HttpResult<List<ParsedMenuItem>>> => {
  // if (lang == '') {
  //   lang = defaultLanguage
  // }
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.main
      ? window.__PRELOADED_DATA__.menus.main
      : await (
        await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/main`, {
          credentials: 'include'
        })
      ).json()

  return {
    kind: 'result',
    status: 200,
    value: parse_menu(menuList)
  }
}

const removeLeadingSlash = (s: string): string => (s?.startsWith('/') ? s.slice(1) : s)

export const loadBreadcrumbsApiCall = async (alias: string, lang: Locale): Promise<HttpResult<List<Breadcrumb>>> => {
  const breadcrumbCall = await fetch(
    alias != undefined
      ? `/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/breadcrumb?path=${removeLangFromUrl(alias)}`
      : '/s',
    {
      method: 'GET',
      credentials: 'include'
    }
  )
  let breadcrumbs = (await (await breadcrumbCall).json()) as Breadcrumb[]
  breadcrumbs = breadcrumbs.map((b) => ({ ...b, url: updateUrlLang(b.url, lang) }))

  return {
    kind: 'result',
    status: 200,
    value: List(breadcrumbs)
  }
}

export const loadBreadcrumbs = (alias: string, lang: Locale): AsyncState<List<Breadcrumb>> => {
  return loadingAsyncState((_) =>
    loadBreadcrumbsApiCall(alias, lang).then<HttpResult<List<Breadcrumb>>>((bread) => {
      return bread.kind == 'result'
        ? { kind: 'result', value: bread.value.count() === 1 ? bread.value : bread.value, status: 200 }
        : { kind: 'failed', status: 404 }
    })
  )
}

export const Search = (query: string, bundle: string, page: number = 0, pagesize: number = 10, lang: string): AsyncState<PaginatedItem<SearchResultItem>> => {
  return loadingAsyncState(_ =>
    fetch(
      `/api/v1/search?query=${query}&lang=${lang == "es" ? "ib" : lang}&page=${page}&pagesize=${pagesize}${bundle ? `&bundle=${bundle}` : ''}`,
      { credentials: 'include' }
    ).then(res => {
      if (!res.ok)
        return {
          kind: 'failed',
          status: 500
        }

      window.dataLayer.push({
        event: "event", category: "Search", action: "Search", label: query
      });

      return res.json().then(json => ({
        kind: 'result',
        status: 200,
        value: {
          items: List(json.Results),
          pager: {
            current_page: page,
            items_per_page: pagesize,
            total_items: json.Count,
            total_pages: Math.ceil(json.Count / pagesize)
          }
        }
      }))
    })
  )
}
// export const loadLanguages = async (): Promise<HttpResult<List<string>>> => {
//   const call = await fetch(`/api/drupal/api/available_languages`, {
//     method: 'GET',
//     credentials: 'include'
//   })
//   const languages = await (await call).json()

//   return {
//     kind: 'result',
//     status: 200,
//     value: List(Object.keys(languages))
//   }
// }
export const mockedImageStyleMap = (url: string) => (
  Map<ImageSize<ExtraImages>, string>(
    Array<ImageSize<ExtraImages>>(
      'thumbnail',
      'medium',
      'large'
    ).map(i => [i, url])
  )
)

export type PaginatedItemStone<T> = {
  items: List<T>
  pager: PagerStone
}
export type PagerStone = {
  currentPage: number
  totalItems: number
  totalPages: number
  itemsPerPage: number
}


export const loadOverviewItems = (
  page_kind: PageKind,
  tags: Map<TagTitle, TagValues>,
  // industryTag: string[],
  // typeTag: string[],
  searchQuery: string,
  page_index: number,
  itemsPerPage: number = 10,
  lang: string = getDrupalLanguage(getLangFromUrl())
): AsyncState<PaginatedItemStone<ParsedOverviewDetailItem>> => {
  return loadingAsyncState(async () => {
    try {
      const url = `/api/v1/GetOverviewItems/`
      let tags1 = tags


      const body = {
        pageKind: page_kind,
        file_name: page_kind,
        lang: lang == defaultLanguage ? '' : lang,
        taxonomies_to_filter:
          tags1.map((v, k) =>
          ({
            taxonomy_title: overview_tag_to_taxonomy_title(k),
            taxonomy_items_to_select: v ? v.filter((t) => t != '').map(t => htmlDecode(t)) : []
          })
          ).valueSeq().toArray(),
        searchQuery: searchQuery || '',
        start_index: page_index || 0,
        page_size: itemsPerPage
      }

      const res_fetch = await fetch(url, {
        method: 'post',
        credentials: 'include',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (!res_fetch.ok) {

        return {
          kind: 'result',
          status: 200,
          value: {
            items: List(),
            pager: { currentPage: 0, itemsPerPage: 0, totalItems: 0, totalPages: 0 }
          }
        }
      }

      let res: any = await res_fetch.json()

      const items: ParsedOverviewDetailItem[] = res.Items.map((item) => ({
        Title: htmlDecode(item.Title || ""),
        Tags: item.Tags,
        Description: item.Description ? item.Description : '',
        Link: {
          url: item.LinkUrl ? item.LinkUrl : '',
          title: item.LinkTitle ? item.LinkTitle : ''
        },
        Image: item.Image ? mockedImageStyleMap(item.Image) : undefined,
        ImageAltText: item.ImageAltText ? item.ImageAltText : undefined,
        get_default_data_src: overviewpage_src,
        get_default_data_srcset: overviewpage_srcset,
        Author: item.Author ? item.Author : undefined,
        ReadingTime:
          item.ReadingTime &&
            !isNaN(parseInt(item.ReadingTime)) &&
            parseInt(item.ReadingTime) > 0
            ? parseInt(item.ReadingTime)
            : undefined,
        CreationDate: item.CreationDate
          ? new Date(item.CreationDate).getFullYear() > 1950
            ? moment(new Date(item.CreationDate)).format('YYYY-MM-DD')
            : undefined
          : undefined
      } as ParsedOverviewDetailItem))

      let res1: PaginatedItemStone<ParsedOverviewDetailItem> = {
        items: List(items),
        pager: {
          currentPage: res.PageIndex,
          totalItems: res.TotalCount,
          totalPages: res.NumPages,
          itemsPerPage: res.PageSize
        } as PagerStone
      }

      return {
        kind: 'result',
        status: 200,
        value: res1
      }
    }
    catch (e) {
      console.error(e)
      return {
        kind: 'result',
        status: 200,
        value: {
          items: List(),
          pager: { currentPage: 0, itemsPerPage: 0, totalItems: 0, totalPages: 0 }
        }
      }
    }
  })
}




export const loadTags = (page_kind: PageKind, lang: string, taxonomy: string,

  tags: Map<TagTitle, TagValues>
): AsyncState<string[]> => {


  let taxonomies_to_filter = tags.map((v, k) =>
  ({
    taxonomy_title: overview_tag_to_taxonomy_title(k),
    taxonomy_items_to_select: v ? v.filter((t) => t != '').map(t => htmlDecode(t)) : []
  })
  ).valueSeq().toArray()


  return loadingAsyncState(async () => {
    try {
      const url =
        lang && lang.length > 0 && lang != defaultLanguage
          ? `/api/v1/${lang}/GetTags/${taxonomy}`
          : `/api/v1/GetTags/${taxonomy}`
      const response = await fetch(url,
        {
          method: 'post',
          credentials: 'include',
          body: JSON.stringify({ taxonomies_to_filter }),
          headers: {
            'Content-Type': 'application/json'
          }
        })

      if (!response.ok) return {
        kind: 'result',
        status: 200,
        value: []
      }
      const value0 = await response.json()
      let value = value0.map((v) =>
        htmlDecode(v)
      )

      return {
        kind: 'result',
        status: 200,
        value
      }
    } catch (e) {
      console.error(e)
      return {
        kind: 'failed',
        status: 500
      }
    }
  })
}

export type RegionLanguage = {
  name: string
  locale: Locale
}

export type Region = {
  title: string
  languages: RegionLanguage[]
  flags: string[]
}

export const getRegions = (): Region[] => [
  {
    title: "Australia",
    languages: [
      {
        name: "English",
        locale: "au",
      }
    ],
    flags: [
      "#flag--au"
    ]
  },
  {
    title: "Benelux",
    languages: [
      {
        name: "Nederlands",
        locale: "nl",
      }
    ],
    flags: [
      "#flag--be",
      "#flag--nl",
      "#flag--lu"
    ],
  },
  {
    title: "Finland",
    languages: [
      {
        name: "Suomi",
        locale: "fi",
      }
    ],
    flags: [
      "#flag--fi"
    ]
  },
  {
    title: "France",
    languages: [
      {
        name: "Français",
        locale: "fr",
      }
    ],
    flags: [
      "#flag--fr"
    ]
  },
  {
    title: "Germany",
    languages: [
      {
        name: "Deutsch",
        locale: "de",
      }
    ],
    flags: [
      "#flag--de"
    ]
  },
  {
    title: "Iberia",
    languages: [
      {
        name: "Español",
        locale: "ib",
      }
    ],
    flags: [
      "#flag--es"
    ]
  },
  {
    title: "Italy",
    languages: [
      {
        name: "Italiano",
        locale: "it",
      }
    ],
    flags: [
      "#flag--it"
    ]
  },
  {
    title: "North America",
    languages: [
      {
        name: "English",
        locale: "na",
      },
      {
        name: "Français",
        locale: "na-fr",
      }
    ],
    flags: [
      "#flag--us",
      "#flag--ca",
      "#flag--mx"
    ],
  },  
  {
    title: "Poland",
    languages: [
      {
        name: "Polski",
        locale: "pl",
      }
    ],
    flags: [
      "#flag--pl"
    ]
  },
  {
    title: "United Kingdom",
    languages: [
      {
        name: "English",
        locale: "uk",
      }
    ],
    flags: [
      "#flag--uk"
    ]
  },
  
]


